(() => {
  'use strict';

  // Mark intent to reopen cart when leaving cart for sign-in
  document.addEventListener(
    'click',
    (e) => {
      const continueBtn = e.target instanceof Element ? e.target.closest('[data-n2l-cart-continue]') : null;
      if (continueBtn && continueBtn.closest('#cart-drawer')) {
        e.preventDefault();
        const drawer = document.querySelector('#cart-drawer');
        if (drawer && typeof drawer.close === 'function') drawer.close();
        else {
          const closeBtn = document.querySelector('#cart-drawer [on\\:click="#cart-drawer/close"], #cart-drawer .theme-drawer__close-button');
          if (closeBtn instanceof HTMLElement) closeBtn.click();
        }
        return;
      }

      const link = e.target instanceof Element ? e.target.closest('[data-n2l-cart-signin]') : null;
      if (!link) return;
      try {
        sessionStorage.setItem('n2l_reopen_cart', '1');
      } catch (err) {
        /* ignore */
      }
    },
    true
  );

  // After Customer Accounts return — reopen cart drawer if flagged
  const reopen = () => {
    let should = false;
    try {
      should = sessionStorage.getItem('n2l_reopen_cart') === '1';
      if (should) sessionStorage.removeItem('n2l_reopen_cart');
    } catch (err) {
      return;
    }
    if (!should) return;

    const openDrawer = () => {
      const drawer = document.querySelector('#cart-drawer');
      if (!drawer) return false;
      if (typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }
      // Fallback: click cart trigger
      const trigger = document.querySelector('[data-testid="cart-drawer-trigger"], [aria-controls="cart-drawer"]');
      if (trigger instanceof HTMLElement) {
        trigger.click();
        return true;
      }
      return false;
    };

    // Wait a beat for theme-drawer to upgrade
    window.setTimeout(() => {
      if (!openDrawer()) {
        window.setTimeout(openDrawer, 400);
      }
    }, 250);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reopen);
  } else {
    reopen();
  }
})();
